import { identification } from "../../intake/pages/identification";

export const GuarantorIdentification = identification.clone().setName('guarantor_identification');